import React from 'react';
import { makeStyles, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import H4 from '../../../common/typographys/H4';
import H6 from '../../../common/typographys/H6';
import Subtitle1 from '../../../common/typographys/Subtitle1';
import Body1 from '../../../common/typographys/Body1';

const useStyles = makeStyles(theme => ({
  mainBox: {
    backgroundColor: theme.palette.primary[100],
    padding: '30px',
  },
  identifier: {
    marginTop: '6px'
  },
  descriptionBox: {
    backgroundColor: theme.palette.neutrals[1],
    boxShadow: '0 20px 20px -10px rgba(204, 216, 214, 0.7)',
    padding: '30px 40px',
  },
}));

const PlateiaBeforeDayOrderItem = ({ item }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.mainBox}>
        <Subtitle1>{item.type_name}</Subtitle1>
        <H4>{item.title}</H4>
        {item.identifier && <H6 className={classes.identifier}>{item.identifier}</H6>}
      </Box>
      {item.description && (
        <Box className={classes.descriptionBox}>
          {/* <H6>{item.description}</H6> */}
          {/* <H6 dangerouslySetInnerHTML={{ __html: item.description }} /> */}
          <Body1
            printMultiline
            // className={clsx({ [classes.value]: !biggerText })}
          >
            {item.description}
          </Body1>
        </Box>
      )}
    </>
  );
};

PlateiaBeforeDayOrderItem.propTypes = {
  item: PropTypes.shape({
    type_name: PropTypes.string,
    title: PropTypes.string,
    identifier: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default React.memo(PlateiaBeforeDayOrderItem);
